import { createFileRoute } from '@tanstack/react-router'

import { requirePermission } from 'lib/routeGuards'

import Orgs from 'pages/Orgs'

export const Route = createFileRoute('/_auth/orgs/')({
  beforeLoad: requirePermission(
    (permissions) =>
      (permissions?.global?.some((p) => p.role !== null) ||
        (permissions?.organizations?.filter((p) => p.role !== null)?.length ??
          0) >= 2) ??
      false,
  ),
  component: Orgs,
})
